<template>
  <div
    class="d-flex align-items-center mr-2 notifications-footer__btn"
    :class="{'like-btn': isLike}"
    @click="onClickLike">
    <span
      class="material-icons mr-1">
      thumb_up
    </span>
    <span>
      いいね
    </span>
  </div>
</template>

<script>
export default {
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLike: false,
    }
  },
  computed: {
    initialLike() {
      if (!this.notification || !this.notification.activityResult) return false
      return !!this.notification.activityResult.liked
    },
  },
  watch: {
    initialLike(val) {
      this.isLike = val
    },
  },
  created() {
    this.isLike = this.initialLike
  },
  methods: {
    onClickLike() {
      // いいねの連打によるサーバー負荷軽減のため、押してから500msの間は処理が走らないようにする
      if (this.isProtecting) return
      if (this.isLike) {
        this.$emit('dislike', this.notification.activityResult.id)
      } else {
        this.$emit('like', this.notification.activityResult.id)
      }
      this.isLike = !this.isLike
      // protect開始
      this.isProtecting = true
      // 500ms後にprotect解除
      window.setTimeout(this.clearProtect, 500)
    },
    clearProtect() {
      this.isProtecting = false
    },
  }

}
</script>

<style>

</style>